export default __webpack_public_path__ + "static/media/Lora-BoldItalic.6fdd3d12.ttf";